export default __webpack_public_path__ + "assets/images/ff0f20811dbd1d9448707ac1ca4d2cab.svg";